// Tiny formatting helpers used across pages.

export function fmtDate(iso: string | null | undefined): string {
	if (!iso) return '—';
	const d = new Date(iso);
	if (isNaN(d.getTime())) return iso;
	return d.toLocaleString();
}

export function fmtRelative(iso: string | null | undefined): string {
	if (!iso) return 'never';
	const d = new Date(iso).getTime();
	const diff = Date.now() - d;
	if (diff < 60_000) return 'just now';
	if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
	if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
	return `${Math.floor(diff / 86_400_000)}d ago`;
}

export function fmtBytes(n: number | null | undefined): string {
	if (n === null || n === undefined || !isFinite(n) || n < 0) return '—';
	if (n < 1024) return `${n} B`;
	const units = ['KB', 'MB', 'GB', 'TB', 'PB'];
	let v = n / 1024;
	let i = 0;
	while (v >= 1024 && i < units.length - 1) {
		v /= 1024;
		i++;
	}
	return `${v < 10 ? v.toFixed(2) : v.toFixed(1)} ${units[i]}`;
}

export function fmtCount(n: number | null | undefined): string {
	if (n === null || n === undefined || !isFinite(n)) return '—';
	return n.toLocaleString();
}

/**
 * Two-letter ISO-3166-1 alpha-2 → flag emoji (regional indicator pair).
 * "RO" → "🇷🇴". Returns the globe emoji for unknown / empty codes.
 */
export function flagEmoji(cc: string | null | undefined): string {
	if (!cc || cc.length !== 2) return '🌐';
	const code = cc.toUpperCase();
	const first = code.charCodeAt(0);
	const second = code.charCodeAt(1);
	if (first < 65 || first > 90 || second < 65 || second > 90) return '🌐';
	return String.fromCodePoint(0x1f1e6 + (first - 65), 0x1f1e6 + (second - 65));
}

export function sourceHealth(iso: string | null | undefined): 'healthy' | 'stale' | 'down' {
	if (!iso) return 'down';
	const age = Date.now() - new Date(iso).getTime();
	if (age < 5 * 60_000) return 'healthy';
	if (age < 60 * 60_000) return 'stale';
	return 'down';
}
